<template>
  <div class="container pt-3 pb-5">
    <h2 class="mb-4">Your Cart</h2>
    <button class="btn btn-outline-dark mb-3">
      <router-link class="nav-link" to="/">
        &#8592; Buy More Products
      </router-link>
    </button>
    <div v-if="cartItems.length === 0" class="alert alert-info">
      Your cart is empty.
    </div>
    <div v-else>
      <div
        v-for="(item, index) in cartItems"
        :key="`cart-item-${index}`"
        class="d-flex justify-content-between align-items-center border-bottom mb-3 pb-2"
      >
        <div class="d-flex align-items-center">
          <img
            :src="item.images?.[0] ? `${BASE_IMAGE_PREFIX}/${item.images[0]}` : `${PLACEHOLDER_IMAGE}`"
            alt="Product image"
            class="img-thumbnail me-3"
            style="width: 75px; height: auto"
          />
          <div>
            <h5 class="mb-1">{{ item.title }}</h5>
            <p
              v-if="item.productCategory !== 'stationary'"
              class="mb-1"
            >
              by {{ item.brand }}
            </p>
            <p class="mb-1">
              <span v-if="item.variant.salePrice">
                Price:
                <span class="text-decoration-line-through text-muted">
                  ৳ {{ item.variant.price }}
                </span>
                <span> ৳ {{ item.variant.salePrice }}</span>
              </span>
              <span v-else>
                Price: ৳ {{ item.variant.price }}
              </span>
            </p>
            <small>
              <i>
                {{ item.variant.name }}
              </i>
            </small>
          </div>
        </div>
        <div class="d-flex align-items-center">
          <input
            type="number"
            v-model="item.quantity"
            min="1"
            @change="debounceApiCall(item)"
            class="form-control me-2"
            style="width: 70px"
          />
          <p class="mb-1">
            Total:
            ৳ {{ (item.variant.salePrice || item.variant.price) * item.quantity }}
          </p>
          <button
            class="btn btn-danger btn-sm ms-5"
            @click="removeFromCart(item)"
          >
            X
          </button>
        </div>
      </div>
      <div class="d-flex flex-column align-items-end mt-4">
        <div class="d-flex mb-3">
          <h5 class="me-3">Total Amount:</h5>
          <h5>
            <span v-if="totalAmountBeforeDiscount > totalAmount" class="text-decoration-line-through text-muted">
              ৳ {{ totalAmountBeforeDiscount }}
            </span>
            ৳ {{ totalAmount }}
          </h5>
        </div>
        <button class="btn btn-dark btn-lg"
          @click="proceedToCheckout"
        >
          Proceed To Checkout &#8594;
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { BASE_IMAGE_PREFIX, PLACEHOLDER_IMAGE } from "@/globals";
import { analytics } from '@/services/analytics';

export default {
  name: "WishlistComponent",
  data() {
    return {
      BASE_IMAGE_PREFIX,
      PLACEHOLDER_IMAGE,
      debounceTimeout: null,
    };
  },
  computed: {
    cartItems() {
      return this.$store.getters.cartItems;
    },
    totalAmount() {
      return this.cartItems.reduce((acc, item) => {
        const price =
          item.variant.salePrice || item.variant.price;
        return acc + price * item.quantity;
      }, 0);
    },
    totalAmountBeforeDiscount() {
      return this.cartItems.reduce((acc, item) => {
        return acc + item.variant.price * item.quantity;
      }, 0);
    }
  },
  methods: {
    updateCart(item) {
      this.$store.dispatch("updateCartItemQuantity", {
        _id: item._id,
        quantity: Number(item.quantity),
        variant: item.variant
      });
    },
    removeFromCart(item) {
      this.$store.dispatch("removeFromCart", {
        productId: item._id,
        variant: item.variant
      });
    },
    debounceApiCall(product) {
      clearTimeout(this.debounceTimeout);
      this.debounceTimeout = setTimeout(() => {
        this.updateCart(product);
      }, 300);
    },
    proceedToCheckout() {
    analytics.initiateCheckout(
      this.cartItems,
      this.totalAmount
    )
    this.$router.push('/checkout')
  }
  },
};
</script>

<style scoped>
.img-thumbnail {
  height: auto; /* Adjust height for consistent look */
}
</style>
